<template>
    <el-button @click="exportData">
        {{ exportTitle }}
    </el-button>
    <el-button @click="showImportModal = true">
        {{ importTitle }}
    </el-button>
    <el-dialog
        v-model="showImportModal"
        title="Import Learning Modules"
        width="30%"
        @close="showImportModal = false"
    >
        <el-alert v-if="!!errorMessage" :title="errorMessage" type="error" />
        <el-form
            ref="importForm"
            :model="importForm"
        >
            <div>
                <p>Warning: Importing will <strong>overwrite all existing data</strong>.</p>
                <p>Make sure you have a backup of your data before importing.</p>
            </div>
            <el-form-item label="File">
                <el-upload
                    ref="upload"
                    :auto-upload="false"
                    :file-list="fileList"
                    :limit="1"
                    :show-file-list="true"
                    accept=".json"
                    :on-change="onChangeHandler"
                >
                    <el-button
                        size="small"
                        type="primary"
                    >
                        Select File
                    </el-button>
                    <template #tip>
                        <div class="el-upload__tip">
                            Only .json files are allowed
                        </div>
                    </template>
                </el-upload>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="showImportModal = false">Cancel</el-button>
                <el-button
                    type="primary"
                    @click="importData"
                    :loading="loading"
                >Import</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script setup>
import { computed, ref } from 'vue'
import {ElMessage, ElMessageBox} from 'element-plus'
import lmApi from '../../lmApi'
import store from "~/store";

const emit = defineEmits()

const showImportModal = ref(false)
const importForm = ref({})
const upload = ref(null)
const fileList = ref([])
const learningTabValue = computed(() => store.getters['learnings/learningTabValue'])
const fileData = ref(null)
const loading = ref(false)
const errorMessage = ref('')
const exportTitle = computed(() => {
   return learningTabValue.value === 'user' ? 'Export SS Learning Modules': 'Export Coaches Learning Modules'
})

const importTitle = computed(() => {
    return learningTabValue.value === 'user' ? 'Import SS Learning Modules': 'Import Coaches Learning Modules'
})

const exportData = () => {
    const params = {
        type: learningTabValue.value
    }
    lmApi.export(params).then((response) => {
        const href = URL.createObjectURL(response.data)
        let filename = response.headers['x-suggested-filename']
        filename = filename.replace(/"/g, '')

        const link = document.createElement('a')
        link.href = href
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        URL.revokeObjectURL(href)
    })
}

const importData = () => {
    if(!fileData.value) {
        return
    }

    const data = new FormData()
    data.append('file', fileData.value)
    data.append('type', learningTabValue.value)
    errorMessage.value = ''
    loading.value = true
    lmApi.import(data).then((response) => {
        showImportModal.value = false
        fileList.value = []
        fileData.value = null
        loading.value = false
        ElMessage({
            message: 'Imported successfully',
            type: 'success'
        })
        errorMessage.value = ''
        emit('refresh')
    })
    .catch((err) => {
        loading.value = false
        if (err.response && err.response.status && err.response.status === 422) {
            errorMessage.value = err.response.data.message
        }
        console.log('err', err.response)
    })
}

const onChangeHandler = (file) => {
    fileData.value = file.raw
}
</script>
